var SCM = SCM || {};
SCM.ElementManager = (function () {

    return {
        elementContainsClass: elementContainsClass,
        elementComparator: elementComparator,
        createElement: createElement,
        elementRemoveClass: elementRemoveClass,
        elementAddClass: elementAddClass,
        getFirstElementByClassName: getFirstElementByClassName,
        getElementsByClass: getElementsByClass,
        getElementsByClassList: getElementsByClassList,
        getElementAtTop: getElementAtTop,
        removeElements: removeElements,
        removeElementsByClass: removeElementsByClass,
        removeElementsByClassList: removeElementsByClassList
    };

    // Get info about an element

    function elementContainsClass(elem, className) {
        if (elem) {
            return (' ' + elem.className + ' ').indexOf(' ' + className + ' ') > -1;
        }
        else {
            return false;
        }
    }

    /**
     * Find which element appears earliest on the page.
     * @param {any} left    The node whose position is the base of the comparison
     * @param {any} right   The node whose position is compared to 'left'
     * @returns             -1 if right is after left or left is undefined, 1 if right is before left or right is undefined,
     *                      0 otherwise.
     */
    function elementComparator(left, right) {
        if (left === right) return 0;

        if (left === undefined) return -1;
        if (right === undefined) return 1;

        var position = left.compareDocumentPosition(right);

        // Bit mask to determine the position of the two elements
        if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY)
            return -1;
        else if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS)
            return 1;
        else
            return 0;
    }

    // Create or modify an element

    function createElement(tag, attribs, children) {
        var elem = document.createElement(tag);

        if (Array.isArray(attribs)) {
            children = attribs;
        } else if (attribs) {
            for (var name in attribs) {
                if (name.startsWith('on')) {
                    elem.addEventListener(name.substring(2), attribs[name]);
                } else {
                    elem.setAttribute(name, attribs[name]);
                }
            }
        }

        if (children) {
            for (var i = 0; i < children.length; i++) {
                var child = children[i];
                if (child) {
                    if (!child.nodeType) {
                        elem.appendChild(document.createTextNode(child.toString()));
                    } else {
                        elem.appendChild(child);
                    }
                }
            }
        }

        return elem;
    }

    function elementRemoveClass(elem, className) {
        if (!elementContainsClass(elem, className)) return;

        elem.className = (' ' + elem.className + ' ').replace(' ' + className + ' ', ' ').trim();
    }

    function elementAddClass(elem, className) {
        if (elementContainsClass(elem, className)) return;

        elem.className = elem.className + ' ' + className;
    }

    // Get elements

    function getFirstElementByClassName(elem, className) {
        if (elem) {
            var elems = elem.getElementsByClassName(className);
            if (elems.length > 0) {
                return elems[0];
            }
        } else {
            return elems[0];
        }
    }

    function getElementsByClass(parent, className) {
        if (!parent) {
            return [];
        }
        var elems = parent.getElementsByClassName(className);
        if (elems.length > 0) {
            return Array.prototype.slice.call(elems, 0);
        } else {
            return [];
        }
    }

    function getElementsByClassList(parent, classList) {
        if (!classList) return [];

        var elems = [];
        for (var i = 0; i < classList.length; i++) {
            elems = elems.concat(getElementsByClass(parent, classList[i]));
        }

        return elems;
    }

    function getElementAtTop(paragraphs) {
        var eyeLevel = 60;
        var $window = $(window);

        if (!paragraphs || !paragraphs.length) {
            return;
        }

        var pageTop = $window.scrollTop() + eyeLevel;

        var left = 0;
        var right = paragraphs.length - 1;

        var element = $(paragraphs[0]);
        var elementTop = element.offset().top - parseInt(element.css('marginTop').replace('px', ''));
        var elementBottom;

        if (pageTop < elementTop) {
            return;
        }

        while (left <= right) {
            var idx = Math.floor((left + right) / 2);

            element = $(paragraphs[idx]);
            elementTop = element.offset().top - parseInt(element.css('marginTop').replace('px', ''));
            elementBottom = element.offset().top + element.height();

            if (left === right || pageTop >= elementTop && pageTop <= elementBottom) {
                // Now check for nested elements (like tables within boxed text)
                var tempIndex = idx;
                while (idx != right && pageTop >= elementTop) {
                    idx = tempIndex;
                    tempIndex = tempIndex + 1;
                    element = $(paragraphs[tempIndex]);
                    elementTop = element.offset().top;
                    elementBottom = elementTop + element.height();
                }

                return { elem: paragraphs[idx], idx: idx };
            }

            if (elementTop > pageTop) {
                right = idx - 1;
            } else if (elementBottom < pageTop) {
                left = idx + 1;
            } else {
                return { elem: element[0], idx: idx };
            }
        }

        return {
            elem: paragraphs[Math.min(right, paragraphs.length - 1)],
            idx: Math.min(right, paragraphs.length - 1)
        };
    }

    // Remove elements

    function removeElements(elems) {
        for (var i = 0; i < elems.length; i++) {
            if (elems[i].parentNode != null) {
                elems[i].parentNode.removeChild(elems[i]);
            }
        }
    }

    function removeElementsByClass(parent, className) {
        removeElements(getElementsByClass(parent, className));
    }

    function removeElementsByClassList(parent, classList) {
        removeElements(getElementsByClassList(parent, classList));
    }

})();
